import { fmtDate } from "../lib/roles";
import { Panel } from "./common";

function weekRange() {
  const now = new Date(); now.setHours(0, 0, 0, 0);
  const mon = new Date(now); mon.setDate(now.getDate() - ((now.getDay() + 6) % 7));
  const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
  return [mon, sun];
}

export function WeekShifts({ shifts }) {
  const [mon, sun] = weekRange();
  const week = shifts.filter((s) => s.data && (s.orario || "").trim()).filter((s) => { const dt = new Date(`${s.data}T00:00:00`); return dt >= mon && dt <= sun; }).sort((a, b) => a.data.localeCompare(b.data));
  if (!week.length) return <Panel><p className="text-slate-500">Nessun turno previsto per questa settimana.</p></Panel>;
  return (
    <div className="flex gap-3 overflow-x-auto pb-2" data-testid="home-week-shifts">{week.map((s) => (
      <div key={s.data} className="min-w-[140px] rounded-2xl bg-[var(--navy)] text-white p-4">
        <p className="text-xs uppercase tracking-widest text-white/60">{s.giorno}</p>
        <p className="font-display text-lg font-bold mt-1">{fmtDate(s.data).split(" ").slice(0, 2).join(" ")}</p>
        <p className="text-sm text-[#8fd3d3] mt-2">{s.orario}</p>
      </div>))}
    </div>
  );
}
